const $button = $('.header-mobile-menu');
const $menu = $('.mobile-menu-container');
const $search = $('.header-search-btn');
const $searchBar = $('.header-search-bar');
const $searchBox = $('.header-search-box');
const $searchInput = $('#keyword-search');

$(function () {
  $button.on('click', function () {
    $(this).toggleClass('active');
    $menu.toggleClass(['mobile-menu-shown']);
    $('.header').toggleClass('menu-open');
  });

  $search.on('click', function () {
    $(this).addClass('hidden');
    $searchBar.removeClass('hidden').addClass('show-bar');
    // $searchBox.removeClass('hidden').addClass('show-box');
  });

  $searchInput.on('keypress', function (event) {
    if (event.which == 13) {
      const redirectTo = window.location.origin + '/?s=' + event.target.value;
      window.location.href = redirectTo;
    }
  });

  $('.toggle-flyout-mobile').on('click', function () {
    $(this).children('i').toggleClass('active');
    $(this).closest('.menu-item').toggleClass('flyout-active');

    const flyoutId = $(this).attr('data-flyout-index');
    const selector = `.mobile-flyout-container[data-index = ${flyoutId}]`;
    const flyoutShown = $(selector).attr('data-flyout-shown');

    $(selector).toggleClass('active');

    if (flyoutShown == 0) {
      $('.mobile-flyout-container').attr('data-flyout-shown', 0);

      $(selector).attr('data-flyout-shown', 1);
    }

    if (flyoutShown == 1) {
      $(selector).removeClass('!h-full');
      $(selector).attr('data-flyout-shown', 0);
    }
  });

  $('.header-search-bar-clear').on('click', function () {
    $('#keyword-search').val('');
  });

  $('.toggle-flyout').on('click', function () {
    $('.flyout').removeClass('shown');
    $('.toggle-flyout').addClass('active');
    $(this).children('i').toggleClass('active');
    $('.toggle-flyout').not($(this)).children('i').removeClass('active');

    $(this).parent('.menu-item').toggleClass('flyout-active');
    $('.menu-item').not($(this).parent('.menu-item')).removeClass('flyout-active');

    const flyoutId = $(this).attr('data-index');
    const selector = `.flyout[data-index = ${flyoutId}]`;
    const flyoutShown = $(selector).attr('data-flyout-shown');

    if (flyoutShown == 0) {
      $('.flyout').attr('data-flyout-shown', 0);
      $(selector).addClass('shown');
      $(selector).attr('data-flyout-shown', 1);
    }

    if (flyoutShown == 1) {
      $(selector).removeClass('shown');
      $(selector).attr('data-flyout-shown', 0);
    }
  });

  $(document).on('click', function (event) {
    const searchBarLg = '.search-bar-lg';
    const searchButton = '.header-search-btn';
    const searchBox = '.header-search-box';
    const isClickedOutsideSearchBar = $(event.target).closest(searchBarLg).length === 0;
    const isClickedOutsideSearchBtn = $(event.target).closest(searchButton).length === 0;
    // const isClickedOustideSearchBox = $(event.target).closest(searchBox).length === 0;

    if (isClickedOutsideSearchBar && isClickedOutsideSearchBtn) {
      $(searchBarLg).removeClass('show-bar');
      // $(searchBox).removeClass('show-box');
      $(searchButton).removeClass('hidden');
    }
  });
});
